import * as React from 'react';
import * as classNames from 'classnames';
import useDismissibleAlert from './use_dismissible_alert';

interface IAlertBoxProps {
  color?: 'gray' | 'blue' | 'red' | 'green' | 'orange';
  small?: boolean;
  unpadded?: boolean;
  inline?: boolean;
  children: React.ReactNode;
  dismissibleWithKey?: string;
}

export default function AlertBox({
  color,
  small,
  unpadded,
  inline,
  children,
  dismissibleWithKey,
}: IAlertBoxProps) {
  const classes = classNames(
    'alert-box',
    { 'alert-box--gray': color === 'gray' },
    { 'alert-box--blue': color === 'blue' },
    { 'alert-box--red': color === 'red' },
    { 'alert-box--green': color === 'green' },
    { 'alert-box--orange': color === 'orange' },
    { 'alert-box--small': small },
    { 'alert-box--unpadded': unpadded },
    { 'alert-box--inline': inline },
    { 'alert-box--dismissible': !!dismissibleWithKey },
  );

  const [isDismissed, dismissAlertBox] = useDismissibleAlert(dismissibleWithKey);
  if (dismissibleWithKey && isDismissed) return null;

  return (
    <div className={classes}>
      <div className="alert-box__content">
        {children}
      </div>
      {!!dismissibleWithKey &&
        <button
          type="button"
          onClick={dismissAlertBox}
          className="alert-box__dismiss"
        />
      }
    </div>
  );
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/src/components/alert_box.tsx